import {useEffect, useState} from "react";
import {v2ReactURL} from "../../utils/constant.ts";
import {axiosFunction} from "../../components/commonFunctions";
import LoyaltyPermissionSchema, {LoyaltyPermissionType} from "./LoyaltyRelatedApiZodSchema.ts";
import {apiResponseHandler} from "../../utils/functions/apiResponseHandler.ts";
import { ErrorState } from "../../pages/Contact/MainDataTable.tsx";

const useVLoyaltyRelatedApi = () => {
    const [loyaltyPermissions, setLoyaltyPermissions] = useState<LoyaltyPermissionType | null>(null);
    const [loadingData, setLoadingData] = useState(true);
    const [permissionError, setPermissionError] = useState<ErrorState | null>(null);

    useEffect(() => {
        const fetchVLoyaltyPermissions = async () => {
            setLoadingData(true);
            setPermissionError(null);

            const res = await axiosFunction(`${v2ReactURL}/loyalty/permissions`, "GET");
            const error: ErrorState | null = apiResponseHandler(res, false);
            if (error != null) {
                setPermissionError(error);
                setLoadingData(false);
                return;
            }

            // Validate Response Data
            const validatedData = LoyaltyPermissionSchema.safeParse(res?.data.response);
            if (validatedData.success) {
                setLoyaltyPermissions(validatedData.data);
            } else {
                console.error("API response validation failed:", validatedData.error);
                setPermissionError({
                    code: "422",
                    message: "Data validation failed. Please contact support.",
                });
            }
            setLoadingData(false);
        };

        fetchVLoyaltyPermissions();
    }, []);

    return {loyaltyPermissions, loadingData, permissionError};
};

export default useVLoyaltyRelatedApi;
